import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

export const ACTIVE_LOCALES = gql`
  query SupportLocales {
    locales: activeLocales
  }
`;
const activeLocales = graphql(ACTIVE_LOCALES, { name: 'activeLocales' });

export default compose(activeLocales);
